<template>
  <van-cell-group class="mt-2 py-4" v-if="groupon">
    <van-cell>
      <div class="text-base" slot="title">购买须知</div>
    </van-cell>
    <van-cell>
      <template slot="title">
        <div class="text-ls-400">有效期：</div>
        <div class="text-gray-600 mt-1">{{ groupon.started_at }} 至 {{ groupon.end_at }}（周末、节假日通用）</div>
        <div class="text-ls-400 mt-2">使用时间：</div>
        <div class="text-gray-600 mt-1">8:30 - 21:10</div>
        <div class="text-ls-400 mt-2">使用规则：</div>
        <ul class="text-gray-600 mt-1">
          <li class="mt-1">无需预约，到店消费即可使用;</li>
          <li class="mt-1">可叠加使用，不兑现，不找零;</li>
        </ul>
        <div class="text-ls-400 mt-2" v-if="groupon.desc">购买说明：</div>
        <div class="text-gray-600 mt-1" v-html="groupon.desc"></div>
      </template>
    </van-cell>
  </van-cell-group>
</template>
<script>
export default {
  props: {
    groupon: {
      type: Object,
      default: null
    }
  }
}
</script>
